import type { Ctx } from '@/core/context';
import type { FloorIdT } from '@/content/schema';
import { bus } from '@/core/bus';
import { tr } from '@/i18n';

export const hasItem = (ctx: Ctx, id: string) => ctx.profile.items.includes(id) || ctx.day.items.held.includes(id);

/** 取得道具（永久道具記在 profile，消耗品記在當天） */
export function grantItem(ctx: Ctx, id: string, silent = false): boolean {
  const it = ctx.c.itemById.get(id); if (!it || hasItem(ctx, id)) return false;
  if (it.consumable) ctx.day.items.held.push(id); else ctx.profile.items.push(id);
  bus.emit('sfx', 'item');
  ctx.log(tr("取得道具：{0} {1}", it.icon, it.name), 'good'); ctx.save();
  if (!silent) ctx.ui.card({ name: `${it.icon} ${it.name}`, role: tr("取得道具"), color: '#7fbf98', title: it.pickupLine.speaker,
    text: it.pickupLine.text, sections: [{ label: tr("效果"), items: [it.effectText], tone: 'good' }, { label: tr("注意"), items: [ctx.c.game.disclaimer] }],
    choices: [{ text: tr("收下"), tone: 'primary', fn: () => ctx.ui.close() }] });
  return true;
}

export function consume(ctx: Ctx, id: string): void {
  ctx.day.items.held = ctx.day.items.held.filter(x => x !== id);
}

const PLACEABLE = new Set(['conveyor', 'machine', 'oven', 'kettle', 'drum', 'terminal', 'freezer', 'desk']);
export const canPlaceOn = (kind: string) => PLACEABLE.has(kind);

export function placeGuaiguai(ctx: Ctx, floor: FloorIdT, equipment: string): void {
  ctx.day.items.guaiguai = { floor, equipment };
  ctx.apply({ stress: -15 }, 'guaiguai');
  ctx.day.player.focus = Math.min(100, ctx.day.player.focus + 10);
  ctx.log(tr("把綠色乖乖放在機台旁（非食品接觸位置）"), 'info');
  ctx.ui.toast(tr("🟩 綠色乖乖就定位。心情平靜了一點。……千萬別被駐廠看到。"));
  ctx.world.refreshActors(); ctx.save();
}
export function takeBackGuaiguai(ctx: Ctx): void {
  ctx.day.items.guaiguai = null; ctx.world.refreshActors(); ctx.save();
  ctx.ui.toast(tr("綠色乖乖收回個人物品區了。"));
}

/** 駐廠品保看到乖乖時的喜劇事件（SHORT-004） */
export function auditorSpotsGuaiguai(ctx: Ctx, npcId = 'resident'): void {
  const it = ctx.c.itemById.get('guaiguai')!;
  const ev = ctx.c.eventById.get('SHORT-004');
  const npc = ctx.c.npcById.get(npcId) ?? ctx.c.npcById.get('resident')!;
  ctx.day.items.spotted = true;
  bus.emit('sfx', 'warn');
  ctx.ui.card({ name: npc.name, role: npc.title, color: npc.color, npc: npc.id, badge: { text: tr("SHORT-004｜綠色乖乖警報"), color: '#7fbf98' },
    title: ev?.text, text: it.auditorQuestion ?? tr("請問這個是設備的一部分嗎？"),
    choices: (it.auditorChoices ?? []).map(ch => ({ text: ch.text, fn: () => {
      ctx.apply({ trust: ch.trust, audit: ch.audit }, 'guaiguai');
      ctx.day.items.guaiguai = null;
      ctx.log(tr("駐廠品保發現綠色乖乖：{0}", ch.text), ch.trust < 0 ? 'bad' : 'info');
      ctx.ui.card({ name: npc.name, role: npc.title, color: npc.color, npc: npc.id, text: ch.reply,
        sections: [{ label: tr("提醒"), items: [tr("乖乖可以放，安全檢查還是要做。綠色乖乖是彩蛋，不能拿來藏真正的安全或衛生缺失。")] }],
        choices: [{ text: tr("好"), fn: () => { ctx.ui.close(); ctx.world.refreshActors(); } }] });
      ctx.save();
    } })),
  });
}
